<template>
  <div class="container" @touchmove.prevent>
    <div class="title">手写签名</div>
    <div class="titleB">（请确认是否有跟拍看角度？请确认是否都拍摄完毕？若确认请签字，您的认可对我们非常重要，衷心感谢您的配合与支持！）</div>
    <div class="imgs">
      <canvas ref="canvas" 
            :width="canvasWidth" 
            :height="canvasHeight" 
            @mousedown="startDrawing" 
            @mousemove="draw" 
            @mouseup="endDrawing" 
            @mouseout="endDrawing"
            @touchstart="startDrawing" 
            @touchmove="draw" 
            @touchend="endDrawing">
      </canvas>    
    </div>
    <div class="signatureTime">签字日期：{{signatureTime}}</div>
    <div class="buttons">
      <el-button class="button" @click="clearCanvas">清除签名</el-button>
      <el-button class="button greenButton" @click="submitSignature">提交签名</el-button>
      <el-button class="button" @click="back">返回</el-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { sutmitOrderSignature } from "@/api/m/grapher";
export default {
  data() {
    return {
      drawing: false,
      context: null,
      lastX: 0,
      lastY: 0,
      canvasWidth: 400, // 设置 canvas 宽度
      canvasHeight: 400, // 设置 canvas 高度
      orderId: 0,
      // 签名时间，需要展示的格式为中文的年月日，例如：2023年1月1日
      signatureTime: this.formatChineseDate(new Date().toLocaleDateString()),
      model:{
					orderId: '',
					signatureImgUrl: '',
				},
    };
  },
  created(){
			let self = this;
      // 获取网址中传递过来的参数id和值
			self.orderId = this.$route.query.id;
	},
  mounted() {
    this.context = this.$refs.canvas.getContext('2d');
    this.context.strokeStyle = 'black'; // 设置线条颜色为黑色
    this.context.lineWidth = 2; // 设置线条粗细为2px
    // 设置canvasWidth为屏幕宽度的90%
    this.canvasWidth = window.innerWidth * 0.95;
    // 设置canvasHeight为屏幕高度的60%
    this.canvasHeight = window.innerHeight * 0.63;
    if (window.screen.orientation) {
      window.screen.orientation.lock('portrait');
    }
  },
  methods: {
    startDrawing(e) {
      this.drawing = true;
      const rectB = this.$refs.canvas.getBoundingClientRect();
      if(e.type === 'touchstart') {
        this.lastX = e.touches[0].clientX - rectB.left;
        this.lastY = e.touches[0].clientY - rectB.top;
      } else {
        this.lastX = e.clientX - rectB.left;
        this.lastY = e.clientY - rectB.top;
      }
    },
    draw(e) {
      if(!this.drawing){
        return;
      }
      this.context.beginPath();
      this.context.moveTo(this.lastX, this.lastY);
      const rectB = this.$refs.canvas.getBoundingClientRect();
      if(e.type === 'touchmove') {
        this.lastX = e.touches[0].clientX - rectB.left;
        this.lastY = e.touches[0].clientY - rectB.top;
      } else {
        this.lastX = e.clientX - rectB.left;
        this.lastY = e.clientY - rectB.top;
      }
      this.context.lineTo(this.lastX, this.lastY);
      this.context.stroke();
    },
    endDrawing() {
      this.drawing = false;
    },
    submitSignature() {
      this.load(true, "提交中...");
      let canvas = this.$refs.canvas;
      let dataUrl = canvas.toDataURL();
      let blob = this.dataURLToBlob(dataUrl);

      let formData = new FormData();
      formData.append('file', blob, 'signature.png');

      axios.post('/api/OssUpload/Images', formData).then(response => {
        // 处理响应
        console.log("处理响应："+JSON.stringify(response));

        if(response.data.code==0){
          // 上传成功后的操作
          let self = this;
				  var param = self.model
          param.orderId = self.orderId;
          param.signatureImgUrl = response.data.data[0].path;
          // 提交签名
          sutmitOrderSignature(param).then(response => {
            console.info("+++sutmitOrderSignature response:", response);
            const { code, msg, data } = response;
            this.load(false);
            if(code >=0){
              self.$message({
                message: "提交成功",
                type: "success"
              });
            }else{
              self.$message({
                message: "提交失败",
                type: "fail"
              });
            }

            // 返回上一页并刷新其页面
            location.href = "/Grapher/SignatureDetail?id=" + self.orderId

          })
          .catch(response => {
            Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
          });
        }
      })
        .catch(error => {
          // 处理错误
          console.log("处理错误:"+error);
        });
    },
    dataURLToBlob(dataUrl) {
      let arr = dataUrl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while(n--){
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {type:mime});
    },
    clearCanvas() {
      let canvas = this.$refs.canvas;
      let context = canvas.getContext('2d');
      context.clearRect(0, 0, canvas.width, canvas.height);
    },
    back(){
      // 返回上一页
      this.$router.go(-1);
    },
    formatChineseDate(dateString){
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return `${year}年${month}月${day}日`;
    }
  }
}
</script>

<style lang="less" scoped>
.container {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	// height: 100vh;
  .title{
    margin-top: 15px;
	  font-size: 19px;
	  text-align: center;
	  width: 80%;
  }
  .titleB{
    margin-top: 10px;
    font-size: 14px;
    text-align: center;
    width: 90%;
    line-height: 18px;
  }
  .imgs{
    margin-top: 10px;
    /* 排在最前面 */
    z-index: 9999;
    /* 一个像素粗的外框 */
    border: 1px solid #1e1e1e;
    width: 95vw;
    height: 63vh;
  }
  .signatureTime{
    margin-top: 5px;
    text-align: right;
    font-size: 12px;
    height: 20px;
    width: 95%;
  }
  .buttons{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
  }
  .button{
    margin-left: 2px;
    margin-right: 2px;
    font-size: 16px !important;
    width: 110px;
    border: 1px solid #999999;
  }
  .greenButton{
    background-color: green;
    color: white;
    border: 1px solid green;
  }
canvas {
    /**边距为0 */
    margin: 0;
    background-color: #ffffff;
}
}
</style>


// WEBPACK FOOTER //
// src/views/grapher/signature.vue